import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import AboutPakdePage from 'containers/pages/webManagement/aboutPakde/List'
import AboutPakdeForm from 'containers/pages/webManagement/aboutPakde/Form'

const aboutPakde = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/web-management/about-pak-d') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementabout-pak-d-read') > -1) {
      return <AboutPakdePage location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementabout-pak-d-write') > -1) {
      return <AboutPakdeForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

aboutPakde.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default aboutPakde
